import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BorrowersState {
  readIds: number[];
}

const initialState: BorrowersState = {
  readIds: [],
};

const borrowersSlice = createSlice({
  name: "borrowers",
  initialState,
  reducers: {
    addReadId: (state, action: PayloadAction<number>) => {
      if (!state.readIds.includes(action.payload)) {
        state.readIds.push(action.payload);
      }
    },
    clearReadIds: (state) => {
      state.readIds = [];
    },
  },
});

export const { addReadId, clearReadIds } = borrowersSlice.actions;
export default borrowersSlice.reducer;
